import { EscrowStatusFilterEnum } from 'src/graphql/schema';

export const filterOptions = {
  status: {
    label: 'Status',
    items: [
      {
        value: EscrowStatusFilterEnum.Draft,
        label: 'Draft',
      },
      {
        value: EscrowStatusFilterEnum.AdminReview,
        label: 'Setup',
      },
      {
        value: EscrowStatusFilterEnum.Onboarding,
        label: 'Review',
      },
      {
        value: EscrowStatusFilterEnum.AwaitingSignature,
        label: 'Awaiting signature',
      },
      {
        value: EscrowStatusFilterEnum.Signed,
        label: 'Signed',
      },
      {
        value: EscrowStatusFilterEnum.PendingActivation,
        label: 'Pending activation',
      },
      {
        value: EscrowStatusFilterEnum.Active,
        label: 'Active',
      },
      {
        value: EscrowStatusFilterEnum.Terminated,
        label: 'Terminated',
      },
    ],
  },
  requests: {
    label: 'Requests',
    items: [
      {
        value: EscrowStatusFilterEnum.TerminationRequested,
        label: 'Termination requests',
      },
      {
        value: EscrowStatusFilterEnum.ChangesSuggested,
        label: 'Change requests',
      },
    ],
  },
};
